import React from 'react'
import styled from 'styled-components'
import StyledText from './StyledComponents/StyledText'

const Badge = ({ borderColor, bgColor, color, borderRadius, text, fontSize, fontWeight, fontStyle, padding, onClick }: {onClick?: () => void, borderColor?: string, padding?: string, bgColor?: string, color?: string, borderRadius?: string, text?: string, fontSize?: string, fontWeight?: number, fontStyle?: string }) => {
    return (
        <StyledBadge bgColor={bgColor} borderRadius={borderRadius} padding={padding} borderColor={borderColor} onClick={onClick}>
            <StyledText fontSize={fontSize} fontWeight={fontWeight} textColor={color} fontStyle={fontStyle}>{text}</StyledText>
        </StyledBadge>
    )
}

const StyledBadge = styled.div<{ bgColor?: string, borderRadius?: string, padding?: string, borderColor?: string }>`
display: inline-block;
border: ${({ borderColor }) => borderColor ? `1px solid ${borderColor}` : 'none'};
background-color: ${({ bgColor }) => bgColor ? bgColor : '#E5E5E5'};
border-radius: ${({ borderRadius }) => borderRadius ? borderRadius : '5px'};
padding: ${({ padding }) => padding ? padding : ' 3px 11px'};
`

export default Badge
